import { LitCheckbox } from "@/components/Checkbox/LitCheckbox";
import { useRef, useEffect } from "react";
import { Table } from "@tanstack/react-table";
import { RegistrantRow } from "../types";

type Props = {
  table: Table<RegistrantRow>;
  isFinalized: boolean;
};

export default function SelectAllHeaderCheckbox({ table, isFinalized }: Props) {
  const inputRef = useRef<HTMLInputElement>(null);

  const checked = table.getIsAllRowsSelected();
  const indeterminate = table.getIsSomeRowsSelected();

  useEffect(() => {
    if (inputRef.current) inputRef.current.indeterminate = indeterminate;
  }, [indeterminate]);

  return isFinalized ? null : (
    <label className="inline-block relative w-5 h-5">
      <LitCheckbox
        checked={checked}
        indeterminate={indeterminate}
        onChange={() => {}}
        style={{ pointerEvents: "none", width: 20, height: 20 }}
        aria-hidden
      />
      <input
        className="absolute top-0 left-0 w-5 h-5 opacity-0 m-0 cursor-pointer"
        ref={inputRef}
        type="checkbox"
        checked={checked}
        onChange={(e) => table.toggleAllRowsSelected(e.target.checked)}
        aria-label="Select all rows"
      />
    </label>
  );
}
